import PropTypes from 'prop-types';
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const Loading = ({ children, size, style, thickness }) => (
  <div
    style={{
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: '100%',
      height: '100%',
      minHeight: 400,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      ...style,
    }}
  >
    <CircularProgress
      // color='#88AD33'
      size={size}
      thickness={thickness}
    />
    {children}
  </div>
);

Loading.propTypes = {
  children: PropTypes.node,
  size: PropTypes.number,
  style: PropTypes.object,
  thickness: PropTypes.number,
};
Loading.defaultProps = {
  size: 32,
  thickness: 8,
};

export default Loading;
